<script>
    require('bootstrap');
    import Vue from 'vue'
    import DiffChart from './DiffChart'
    import router from './../../router'

    export default {
        template: `

    <div>
        <h4 class="title">{{ t('Products') }}</h4>
        <diff-chart :config="config.shop" :data="shop" />
            </div>`

        ,
        props: {
            refererPrefix: {
                type: String
            },
            filters: {
                type: Array
            }
        },
        data() {
            let _this = this;
            return {
                currentDuplicates: [],
                showDuplicatesModal: false,
                shop: [],
                config: {
                    shop: {
                        columns: [
                            {
                                label: '<*,-10%)',
                                color: '#51bcff',
                            },
                            {
                                label: '<-10%,-5%)',
                                color: '#56fffc',
                            },
                            {
                                label: '<-5%,-3%)',
                                color: '#5cffc3',
                            },
                            {
                                label: '<-3%,-0.5%)',
                                color: '#68ff92',
                            },
                            {
                                label: '<-0.5%,0.5%)',
                                color: '#99ff5f',
                            },
                            {
                                label: '<0,5%,3%',
                                color: '#e3ff8a',
                            },
                            {
                                label: '<3%,5%)',
                                color: '#fff380',
                            },
                            {
                                label: '<5%,10%)',
                                color: '#ffa569',
                            }
                            ,
                            {
                                label: '<10%,*>',
                                color: '#ff866a',
                            }
                        ],
                        callback: function (item, node) {
                            let routeData = router.resolve({name: 'offer-analysis-shop',
                                params: {
                                    category: item['category'],
                                    shop: item['shop'],
                                    brand: item['brand'],
                                    group: node
                                }
                            });

                            let serializedFilters = _this.$serialize(_this.filters);
                            window.open(routeData.href + '?refererPrefix=' + _this.refererPrefix + (serializedFilters.length > 0 ? '&' + serializedFilters : ''), '_blank');
                        }
                    }
                }
            }
        },
        components: {
            DiffChart,
        },
        mounted() {
        },
        methods: {
            showDuplicates(items) {
                this.currentDuplicates = items;
                this.showDuplicatesModal = true;
            }
        }
    }
</script>

<style>
    .tab-content {
        background: #fff;
        padding: 20px;
    }

    .price-history-content {
        width: 450px;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 550px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }

    .modal-body {
        margin: 10px 0;
    }

    .modal-enter .modal-container, .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    canvas {
        /*width:100%;*/
    }
</style>


// WEBPACK FOOTER //
// OfferAnalysisDetail.vue?13e73152